import { useTranslation } from "react-i18next";
import Header from "@/components/main/Header";
import Footer from "@/components/main/Footer";
import Banner from "@/components/learn/Banner";
import styled from "styled-components";
import CompositionItem from "@/components/learn/what-is-body-composition/CompositionItem";
import ResultSheet from "@/components/products/detail/ResultSheet";
import { IFontProps, TResultSheet } from "@/typings/Props";
import Contents from "@/components/main/Contents";
import { media } from "@/styles/media";
import { theme } from "@/styles/theme";

type TCompositionItemData = {
  id: number;
  keyword_1: string;
  keyword_2: string;
  desc: string;
  imgPath: string;
};

type THealthIssues = {
  title: string;
  list: string[];
};

export default function Home() {
  const { t } = useTranslation();
  const compositionItemDatas: TCompositionItemData[] = [
    {
      id: 1,
      keyword_1: t("menu.learn.composition-item.water"),
      keyword_2: t("menu.learn.composition-item.Edema"),
      desc: t("menu.learn.composition-item.desc-1"),
      imgPath: "/learn/what-is-body-composition/WIBC_USP_1.png",
    },
    {
      id: 2,
      keyword_1: t("menu.learn.composition-item.protein"),
      keyword_2: t("menu.learn.composition-item.sarcopenia"),
      desc: t("menu.learn.composition-item.desc-2"),
      imgPath: "/learn/what-is-body-composition/WIBC_USP_2.png",
    },
    {
      id: 3,
      keyword_1: t("menu.learn.composition-item.mineral"),
      keyword_2: t("menu.learn.composition-item.osteoporosis"),
      desc: t("menu.learn.composition-item.desc-3"),
      imgPath: "/learn/what-is-body-composition/WIBC_USP_3.png",
    },
    {
      id: 4,
      keyword_1: t("menu.learn.composition-item.fat"),
      keyword_2: t("menu.learn.composition-item.obesity"),
      desc: t("menu.learn.composition-item.desc-4"),
      imgPath: "/learn/what-is-body-composition/WIBC_USP_4.png",
    },
  ];
  const analysisDatas: TResultSheet[] = [
    {
      id: 1,
      category: t("menu.learn.analysis.category-1"),
      title: t("menu.learn.analysis.title-1"),
      desc: t("menu.learn.analysis.desc-1"),
      image: "/learn/what-is-body-composition/Bioelectric-Impedance-Analysis-BIA.webp",
    },
    {
      id: 2,
      category: t("menu.learn.analysis.category-2"),
      title: t("menu.learn.analysis.title-2"),
      desc: t("menu.learn.analysis.desc-2"),
      image: "/learn/what-is-body-composition/DEXA.webp",
    },
    {
      id: 3,
      category: t("menu.learn.analysis.category-3"),
      title: t("menu.learn.analysis.title-3"),
      desc: t("menu.learn.analysis.desc-3"),
      image: "/learn/what-is-body-composition/MRI.webp",
    },
    {
      id: 4,
      category: t("menu.learn.analysis.category-4"),
      title: t("menu.learn.analysis.category-4"),
      desc: t("menu.learn.analysis.desc-4"),
      image: "/learn/what-is-body-composition/Skinfold-Thickness.webp",
    },
    {
      id: 5,
      category: t("menu.learn.analysis.category-5"),
      title: t("menu.learn.analysis.category-5"),
      desc: t("menu.learn.analysis.desc-5"),
      image: "/learn/what-is-body-composition/Hydrostatic-Weighing.webp",
    },
    {
      id: 6,
      category: t("menu.learn.analysis.category-6"),
      title: t("menu.learn.analysis.category-6"),
      desc: t("menu.learn.analysis.desc-6"),
      image: "/learn/what-is-body-composition/Air-Displacement.webp",
    },
  ];
  const healthIssuesDatas: THealthIssues[] = [
    {
      title: t("menu.learn.health-issues.item-1.title"),
      list: [
        t("menu.learn.health-issues.item-1.item-1"),
        t("menu.learn.health-issues.item-1.item-2"),
        t("menu.learn.health-issues.item-1.item-3"),
        t("menu.learn.health-issues.item-1.item-4"),
        t("menu.learn.health-issues.item-1.item-5"),
        t("menu.learn.health-issues.item-1.item-6"),
        t("menu.learn.health-issues.item-1.item-7"),
        t("menu.learn.health-issues.item-1.item-8"),
        t("menu.learn.health-issues.item-1.item-9"),
        t("menu.learn.health-issues.item-1.item-10"),
        t("menu.learn.health-issues.item-1.item-11"),
        t("menu.learn.health-issues.item-1.item-12"),
        t("menu.learn.health-issues.item-1.item-13"),
        t("menu.learn.health-issues.item-1.item-14"),
        t("menu.learn.health-issues.item-1.item-15"),
        t("menu.learn.health-issues.item-1.item-16"),
      ],
    },
    {
      title: t("menu.learn.health-issues.item-2.title"),
      list: [
        t("menu.learn.health-issues.item-2.item-1"),
        t("menu.learn.health-issues.item-2.item-2"),
        t("menu.learn.health-issues.item-2.item-3"),
        t("menu.learn.health-issues.item-2.item-4"),
        t("menu.learn.health-issues.item-2.item-5"),
        t("menu.learn.health-issues.item-2.item-6"),
        t("menu.learn.health-issues.item-2.item-7"),
        t("menu.learn.health-issues.item-2.item-8"),
        t("menu.learn.health-issues.item-2.item-9"),
        t("menu.learn.health-issues.item-2.item-10"),
      ],
    },
    {
      title: t("menu.learn.health-issues.item-3.title"),
      list: [
        t("menu.learn.health-issues.item-3.item-1"),
        t("menu.learn.health-issues.item-3.item-2"),
        t("menu.learn.health-issues.item-3.item-3"),
        t("menu.learn.health-issues.item-3.item-4"),
        t("menu.learn.health-issues.item-3.item-5"),
        t("menu.learn.health-issues.item-3.item-6"),
        t("menu.learn.health-issues.item-3.item-7"),
        t("menu.learn.health-issues.item-3.item-8"),
      ],
    },
  ];
  return (
    <>
      <Header />
      <Banner
        Bg="/learn/banner/What_is_Body_Composition-1.png"
        Headline={t("gnb.learn")}
        Title={t("menu.learn.what-is-body-composition") + "?"}
        Desc={t("menu.learn.what-is-body-composition.desc")}
      />
      <Container>
        <CompositionItemWrapper>
          {compositionItemDatas.map((data) => {
            return <CompositionItem key={data.id} {...data} />;
          })}
        </CompositionItemWrapper>
        <MeasureWrapper>
          <MeasureImgWrapper>
            <Img src="/main/header/Guiding-Principles-2.png" alt="inbody-image" />
          </MeasureImgWrapper>
          <MeasureContent>
            <MeasureTitle dangerouslySetInnerHTML={{ __html: t("menu.learn.measure.title") }} />
            <MeasureDesc>{t("menu.learn.measure.desc")}</MeasureDesc>
          </MeasureContent>
        </MeasureWrapper>
        <AnalysisWrapper>
          <AnalysisTitleWrapper>
            <AnalysisTitle>{t("menu.learn.analysis.title")}</AnalysisTitle>
            <AnalysisDesc>{t("menu.learn.analysis.desc")}</AnalysisDesc>
          </AnalysisTitleWrapper>
          <ResultSheet
            datas={analysisDatas}
            $contentHeight="575px"
            $titleColor={theme.colors.primary}
            $imgWidth="76%"
            $textWidth="100%"
            $marginTop="35px"
            $AreaMarginTop="25px"
          />
        </AnalysisWrapper>
        <BMIContentWrapper>
          <BMIContentTitle>{t("menu.learn.how-can-be-bmi.title")}</BMIContentTitle>
          <BMIContentItemWrapper>
            <BMIContentItem>
              <P $fontSize="2rem" $fontWeight={theme.fontWeights.bold}>
                {t("menu.learn.how-can-be-bmi.item.title-1")}
              </P>
              <P $marginTop="50px" $lineHeight="150%">
                {t("menu.learn.how-can-be-bmi.item.desc-1")}
              </P>
            </BMIContentItem>
            <BMIContentItem>
              <P $fontSize="2rem" $fontWeight={theme.fontWeights.bold}>
                {t("menu.learn.how-can-be-bmi.item.title-2")}
              </P>
              <P $marginTop="50px" $lineHeight="150%">
                {t("menu.learn.how-can-be-bmi.item.desc-2")}
              </P>
            </BMIContentItem>
          </BMIContentItemWrapper>
        </BMIContentWrapper>
        <HealthIssuesWrapper>
          <HealthIssuesTitle>
            <P $fontSize="3rem" $fontWeight={theme.fontWeights.bold} $fontColor={theme.colors.primary}>
              {t("menu.learn.health-issues.title")}
            </P>
            <br />
            <P $fontColor={theme.colors.text.grayLight} $lineHeight="150%">
              {t("menu.learn.health-issues.desc")}
            </P>
          </HealthIssuesTitle>
          {healthIssuesDatas.map((item, i) => {
            return (
              <HealthIssuesList key={i}>
                <P
                  $fontSize="1.4rem"
                  $lineHeight="200%"
                  $fontColor={theme.colors.primary}
                  style={{ borderBottom: `1px solid ${theme.colors.text.grayLight}`, marginBottom: "20px" }}
                >
                  {item.title}
                </P>
                <ul data-aos="fade-up" data-aos-easing="ease-out" data-aos-delay="100 * i" data-aos-duration="500">
                  {item.list.map((data, j) => {
                    return <Li key={j}>{data}</Li>;
                  })}
                </ul>
              </HealthIssuesList>
            );
          })}
        </HealthIssuesWrapper>
        <Contents
          title={t("main.contents.lets-get-in-touch")}
          desc={t("main.contents.lets-get-in-touch.desc")}
          link={"/contact/contact-us/"}
        />
      </Container>
      <Footer />
    </>
  );
}

const Container = styled.div`
  width: 100%;
  height: auto;
`;
const CompositionItemWrapper = styled.div`
  width: 100%;
  min-height: 528px;
  margin-top: 20px;
  margin-bottom: 60px;
  display: flex;
  justify-content: center;
  gap: 10px;
  ${media.tablet`
    flex-wrap: wrap;
    justify-content: center;
  `}
`;
const MeasureWrapper = styled.div`
  width: 100%;
  min-height: 385px;
  display: flex;
  margin-bottom: 60px;
  padding: 0 10px;
`;
const MeasureContent = styled.div`
  width: 100%;
  height: auto;
  padding: 42px 20px 42px 30px;
  margin-bottom: 16px;

  ${media.tablet`
    margin: 0;
  `}
`;
const MeasureTitle = styled.p`
  white-space: pre-wrap;
  margin-bottom: 20px;
  font-size: 3rem;
  font-weight: ${theme.fontWeights.bold};
  color: ${theme.colors.text.grayDark};
`;
const MeasureDesc = styled.p`
  white-space: pre-wrap;
  line-height: 150%;
  color: ${theme.colors.text.grayLight};
`;

const MeasureImgWrapper = styled.div`
  width: 50%;
  min-height: 100%;
  aspect-ratio: 1.7;
  padding: 0 10px;
  margin-bottom: 16px;
  overflow: hidden;

  ${media.tablet`
    display: none;
  `}
`;
const Img = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 20px;
  object-fit: cover;
`;
const AnalysisWrapper = styled.div`
  width: 100%;
  height: auto;
`;
const AnalysisTitleWrapper = styled.div`
  width: 100%;
  padding: 0 20px;
  padding-bottom: 10px;
`;
const AnalysisTitle = styled.p`
  margin-bottom: 24px;
  font-size: 2.8rem;
  font-weight: ${theme.fontWeights.bold};
  text-align: center;
  color: ${theme.colors.primary};
`;
const AnalysisDesc = styled.p`
  line-height: 150%;
  text-align: center;
  white-space: pre-wrap;
  color: ${theme.colors.text.grayLight};
`;
const P = styled.p<IFontProps>`
  width: 100%;
  padding: ${(props) => props.$padding};
  margin-top: ${(props) => props.$marginTop};
  font-weight: ${(props) => props.$fontWeight};
  font-size: ${(props) => props.$fontSize};
  line-height: ${(props) => props.$lineHeight};
  text-align: ${(props) => props.$textAlign};
  flex-grow: 1;
  white-space: pre-wrap;
  color: ${(props) => props.$fontColor};
`;
const BMIContentWrapper = styled.div`
  width: 100%;
  height: auto;
  margin-top: -100px;
  ${media.tablet`
  margin-top: 70px;
  `}
`;
const BMIContentItemWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  ${media.tablet`
    flex-direction: column;
    flex-wrap: wrap;
  `}
`;
const BMIContentItem = styled.div`
  width: 40%;
  min-height: 542px;
  height: auto;
  margin: 10px;
  padding: 65px 36px;
  border-radius: 10px;
  background-color: ${theme.colors.background.white};
  ${media.tablet`
    width: 97%;
    min-height: 0;
  `}
  &:hover {
    transition: ease-out 0.3s;
    background-color: ${theme.colors.primary};
    ${P} {
      color: ${theme.colors.text.white};
      transition: 0.3s ease-out;
    }
  }
`;

const BMIContentTitle = styled.p`
  font-size: 3rem;
  font-weight: ${theme.fontWeights.bold};
  text-align: center;
  padding: 40px;
  color: ${theme.colors.primary};

  ${media.tablet`
      text-align: left;
  `}
`;

const HealthIssuesWrapper = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  padding: 50px;
  ${media.tablet`
     flex-wrap: wrap;
  `}
`;
const HealthIssuesTitle = styled.div`
  position: sticky;
  top: 50px;
  width: 37%;
  height: 100%;
  margin-bottom: 16px;
  padding: 0 25px;
  ${media.tablet`
    position: static;
    padding: 0px;
    width: 100%;
    `}
`;
const HealthIssuesList = styled.div`
  width: 360px;
  height: 100%;
  margin-left: 30px;
  ${media.tablet`
    margin: 30px 0 0 0;
    width: 100%;
  `}
`;
const Li = styled.li`
  list-style: none;
  color: ${theme.colors.text.grayLight};
  line-height: 270%;
  border-bottom: 1px solid rgba(103, 103, 103, 0.45);
`;
